import { projectsDataStore } from "Stores/ProjectsStore";
import { API_URL } from "General/APIEndpoints";
import { ObjectDataStore } from "Stores/RESTStoreInstances/ObjectDataStore";
import { action, runInAction, observable, makeObservable } from "mobx";
import { API } from "General/API";
import { handleStoreState } from "Stores/RESTStore/CoreStore";
import { groupListStore } from "Pages/Project/Groups/Stores/GroupsStore";
import { userInfoStore } from "Stores";

class PrintJobSettingsStore extends ObjectDataStore<API_PrintJobSettings> {
  constructor() {
    super();

    makeObservable(this, {
      allowPrint: observable,
      editSettings: action.bound,
    });

    this.data = {} as API_PrintJobSettings;
  }
  allowPrint: boolean = false;

  url() {
    return API_URL.PROJECTS.getPrintJobSettings(projectsDataStore.projectId);
  }

  @handleStoreState()
  async editSettings(formData: API_PrintJobSettings) {
    try {
      const data = { ...this.data, ...formData };
      await API.editData(this.url(), data);
      runInAction(() => {
        this.data = data;
      });
    } catch (err) {
      throw err;
    }
  }

  isUserAlowToPrint() {
    const { restrictedGroupId } = projectsDataStore.printJobSettings;
    const restrictedGroup = groupListStore.getItem(restrictedGroupId);
    const isAllow =
      restrictedGroupId === -108 ||
      (restrictedGroup && restrictedGroup.groupMembers.some((member) => member.id === userInfoStore.id));

    runInAction(() => {
      this.allowPrint = projectsDataStore.isAdmin || isAllow;
    });
  }
}

const printJobSettingsStore = new PrintJobSettingsStore();

export { printJobSettingsStore };
